import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ThemeColor {
  name: string;
  primary: string;
  primaryHover: string;
  primaryActive: string;
  primaryLight: string;
}

export const themes: Record<string, ThemeColor> = {
  orange: {
    name: '橙色',
    primary: '#f37022',
    primaryHover: '#e05f1a',
    primaryActive: '#cc4f15',
    primaryLight: '#fff7e6',
  },
  blue: {
    name: '蓝色',
    primary: '#1890ff',
    primaryHover: '#40a9ff',
    primaryActive: '#096dd9',
    primaryLight: '#e6f7ff',
  },
  green: {
    name: '绿色',
    primary: '#52c41a',
    primaryHover: '#73d13d',
    primaryActive: '#389e0d',
    primaryLight: '#f6ffed',
  },
  purple: {
    name: '紫色',
    primary: '#722ed1',
    primaryHover: '#9254de',
    primaryActive: '#531dab',
    primaryLight: '#f9f0ff',
  },
  red: {
    name: '红色',
    primary: '#f5222d',
    primaryHover: '#ff4d4f',
    primaryActive: '#cf1322',
    primaryLight: '#fff1f0',
  },
  cyan: {
    name: '青色',
    primary: '#13c2c2',
    primaryHover: '#36cfc9',
    primaryActive: '#08979c',
    primaryLight: '#e6fffb',
  },
  pink: {
    name: '粉色',
    primary: '#eb2f96',
    primaryHover: '#f759ab',
    primaryActive: '#c41d7f',
    primaryLight: '#fff0f6',
  },
};

interface ThemeState {
  currentTheme: string;
  setTheme: (theme: string) => void;
  getCurrentThemeConfig: () => ThemeColor;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      currentTheme: 'orange', // 默认橙色主题
      setTheme: (theme: string) => {
        if (themes[theme]) {
          set({ currentTheme: theme });
          // 应用主题到CSS变量
          const themeConfig = themes[theme];
          const root = document.documentElement;
          root.style.setProperty('--primary-color', themeConfig.primary);
          root.style.setProperty('--primary-color-hover', themeConfig.primaryHover);
          root.style.setProperty('--primary-color-active', themeConfig.primaryActive);
          root.style.setProperty('--primary-color-light', themeConfig.primaryLight);
        }
      },
      getCurrentThemeConfig: () => {
        return themes[get().currentTheme] || themes.orange;
      },
    }),
    {
      name: 'theme-storage',
      onRehydrateStorage: () => (state) => {
        // 恢复主题时应用CSS变量
        if (state) {
          const themeConfig = themes[state.currentTheme] || themes.orange;
          const root = document.documentElement;
          root.style.setProperty('--primary-color', themeConfig.primary);
          root.style.setProperty('--primary-color-hover', themeConfig.primaryHover);
          root.style.setProperty('--primary-color-active', themeConfig.primaryActive);
          root.style.setProperty('--primary-color-light', themeConfig.primaryLight);
        }
      },
    }
  )
);
